<template>
  <el-dialog
      v-model="dialogVisible"
      :title="formData.ID?'编辑分组':'新增分组'"
      width="800px"
      :close-on-click-modal="false"
      :append-to-body="true"
      :show-close="true"
      :before-close="handleClose">
    <div class="dialog-item1">
      <el-form :model="formData"
               label-width="auto"
               :rules="rules"
               class="el-form-box" ref="ruleFormRef">
        <el-row :gutter="10">
          <el-col :span="24" >
            <el-form-item label="年份：" prop="year" >
              <el-select v-model="formData.year" style="width: 100px" :disabled="true" >
                <el-option v-for="i of YEARS" :key="i.ID" :value="i.ID" :label="i.Name" />
              </el-select>
            </el-form-item>

          </el-col>
          <el-col :span="24" >
            <el-form-item label="分组名称：" prop="name">
              <el-input v-model.trim="formData.name" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="参赛组别：" prop="level" >
              <el-select v-model="formData.level">
                <el-option v-for="i of LEVELS" :key="i.ID" :value="i.ID" :label="i.Name" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="参赛区域：" prop="zoneId" >
<!--              多选 todo-->
<!--              <el-checkbox-group v-model="formData.zone_id">-->
<!--                <el-checkbox :value="i"  v-for="i of zones" :key="i">-->
<!--                  {{i}}-->
<!--                </el-checkbox>-->
<!--              </el-checkbox-group>-->
              <!--              单选 todo-->
              <el-radio-group v-model="formData.zoneId">
                <el-radio :value="i.ID"  v-for="i of zones" :key="i">{{i.Name}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="save(ruleFormRef)"
                   :loading = "loading"
        >确定</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {ref, defineProps, defineEmits, reactive,onMounted} from 'vue';
import {ElMessage} from "element-plus";
import {validateForm} from "@/utils/formValidate";
import {getYears} from "@/utils/commonSetting"
import {addWorkgroup, updateWorkgroup} from "@/api/workgroupAdmin";
const emits = defineEmits(['close', 'success'])
const dialogVisible = ref(true)
const ruleFormRef = ref()
const YEARS = getYears()
// import {LEVELS} from "@/utils/commonSetting";
import {getZones} from "@/api/zoneAdmin";
const zones = ref([]) // 参赛区域
const LEVELS = [
  {ID:1,Name:"专科组"},
  {ID:2,Name:"本科生组"},
  {ID:3,Name:"研究生组"},
  {ID:4,Name:"所有分组"},
]
var formData = reactive({
  ID:null,
  name: null, // 名称
  level:"",// 级别
  zoneId:null, // 参赛区域
  year:new Date().getFullYear(), // 年份
})
const loading = ref(false)
const rules = ({
  year: [{required: true, message: '请选择年份', trigger: ['change', 'blur']}],
  name: [{required: true, message: '请输入分组名称', trigger: ['change', 'blur']}],
  level: [{required: true, message: '请选择参数组别', trigger: ['change', 'blur']}],
  zoneId: [{required: true, message: '请选择大赛区域', trigger: ['change', 'blur']}],
})

const props = defineProps({
  item: {
    default: {},
  },
  stage:{
    default:null
  }
})
// 开始
onMounted(()=>{
  getZonesCurrentYear()
  if(props.item && props.item.ID){
    formData.ID = props.item.ID
    formData.name = props.item.Name
    formData.level = props.item.Level
    formData.zoneId = props.item.ZoneId?props.item.ZoneId:""
    formData.year = props.item.Year
  }
})
// 获取区域
const getZonesCurrentYear = async ()=>{
  const res = await getZones({year:new Date().getFullYear()})
  if(res.err_code==0){
    zones.value = res.data || []
  }
}
const handleClose = () => {
  dialogVisible.value = false
  emits("close", true)
}
// 保存
const save = async (ruleFormRef) => {
  const isvalidate =await validateForm(ruleFormRef)
  if(!isvalidate){
    return
  }
  loading.value = true
  let res,messPre;
  const params = {
    ...formData,
    stage:props.stage,
  }
  if( formData.ID){
    res = await updateWorkgroup(params)
    messPre = '修改'
  }else{
    res = await addWorkgroup(params)
    messPre = '创建'
  }
  loading.value = false
  if(res.err_code===0){
    ElMessage.success(messPre + "成功")
    emits("success", true)
  }else{
    ElMessage.warning(res.err_msg || messPre + "失败")
  }

}
</script>

<style scoped>
.dialog-item1 {
  width: 100%;
  max-height: 500px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
